import i18n from "i18next"
import {initReactI18next} from "react-i18next"
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector"

import commonDE from "./lang/de/common.json"
import commonEN from "./lang/en/common.json"
import navigationDE from "./lang/de/navigation.json"
import navigationEN from "./lang/en/navigation.json"
import userDE from "./lang/de/user.json"
import userEN from "./lang/en/user.json"
import tenantDE from "./lang/de/tenant.json"
import tenantEN from "./lang/en/tenant.json"
import eexamDE from "./lang/de/eexam.json"
import eexamEN from "./lang/en/eexam.json"
import bookingDE from "./lang/de/booking.json"
import bookingEN from "./lang/en/booking.json"
import infoDE from "./lang/de/info.json"
import infoEN from "./lang/en/info.json"
import settingsDE from "./lang/de/settings.json"
import settingsEN from "./lang/en/settings.json"
import supervisionDE from "./lang/de/supervision.json"
import supervisionEN from "./lang/en/supervision.json"
import siteDE from "./lang/de/site.json"
import siteEN from "./lang/en/site.json"
import examDE from "./lang/de/exam.json"
import examEN from "./lang/en/exam.json"
import adminDE from "./lang/de/admin.json"
import adminEN from "./lang/en/admin.json"
import departureDE from "./lang/de/departure.json"
import departureEN from "./lang/en/departure.json"
import examManagementDE from "./lang/de/examManagement.json"
import examManagementEN from "./lang/en/examManagement.json"
i18n
    .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            de: {
                common: commonDE,
                tenant: tenantDE,
                user: userDE,
                navigation: navigationDE,
                eexam: eexamDE,
                booking: bookingDE,
                info: infoDE,
                settings: settingsDE,
                supervision: supervisionDE,
                site: siteDE,
                exam: examDE,
                admin: adminDE,
                departure: departureDE,
                examManagement: examManagementDE
            },
            en: {
                common: commonEN,
                tenant: tenantEN,
                user: userEN,
                navigation: navigationEN,
                eexam: eexamEN,
                booking: bookingEN,
                info: infoEN,
                settings: settingsEN,
                supervision: supervisionEN,
                site: siteEN,
                exam: examEN,
                admin: adminEN,
                departure: departureEN,
                examManagement: examManagementEN
            },
        },
        fallbackLng: "en",
        debug: false,
        ns: [
            "common",
            "tenant",
            "user",
            "navigation",
            "booking",
            "info",
            "settings",
            "supervision",
            "site",
            "exam", "admin", "departure", "examManagement"
        ],
        defaultNS: "common",
        fallbackNS: "common",
        interpolation: {
            escapeValue: false,
        },
    }).then()

i18n.languages = [
    "en",
    "de",
]

export default i18n
